import AnnotationArrowIcon from "@mui/icons-material/CallMade";
import AnnotationRectangleIcon from "@mui/icons-material/CropDin";
import AnnotationCloudIcon from "@mui/icons-material/FilterDrama";
import AnnotationEllipseIcon from "@mui/icons-material/PanoramaFishEye";

import { ANNOTATION_TYPE } from "../../utils/types";

const annotationTypeMenuIcons = {
  [ANNOTATION_TYPE.ARROW]: <AnnotationArrowIcon />,
  [ANNOTATION_TYPE.CLOUD]: <AnnotationCloudIcon />,
  [ANNOTATION_TYPE.ELLIPSE]: <AnnotationEllipseIcon />,
  [ANNOTATION_TYPE.RECTANGLE]: <AnnotationRectangleIcon />,
};

const AnnotationTypeMenuIcon = ({ type }) => (
  annotationTypeMenuIcons[type] || annotationTypeMenuIcons[ANNOTATION_TYPE.ARROW]
);

export default AnnotationTypeMenuIcon;
